import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { TYPE } from 'theme';
import ReactPlayer from 'react-player';
import { isMobile } from 'react-device-detect';

const Wrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    margin-bottom: -300px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin-bottom: -260px;
    `};

    .control-dots {
        position: absolute;
        bottom: 0;

        ${({ theme }) => theme.mediaWidth.upToSmall`
            bottom: 30px;
        `};

        .dot {
            background: #ccc;
            box-shadow: none;
            width: 16px;
            height: 16px;
            &.selected {
                background: ${({ theme }) => theme.c.primary01};
            }
        }
    }

    .carousel {
        padding-bottom: 240px;

        ${({ theme }) => theme.mediaWidth.upToSmall`
            padding-bottom: 270px;
        `};

        .thumbs-wrapper {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 230px;
            margin: 20px 0;

            .thumbs {
                padding: 0;

                .thumb {
                    width: fit-content !important;
                    border-color: transparent;

                    &.selected {
                        border: 2px solid transparent;
                        border-radius: 10px;
                    }

                    &:not(:last-child) {
                        margin-right: 25px;

                        ${({ theme }) => theme.mediaWidth.upToSmall`
                            margin-right: 5px;
                        `};
                    }
                }
            }
        }

        .slide iframe {
            margin: 0;
            width: 100%;
            border-radius: 20px;
        }
    }
`;

const VideoContainer = styled.div`
    position: relative;
    width: 100%;
`;

const Video = styled.video`
    width: 100%;
    border-radius: 20px;
    margin-bottom: 10px;
`;

const ThumbnailContainer = styled.div`
    width: 270px;
    height: 150px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 160px;
        height: 90px;
    `};
`;

interface VideoItem {
    title: string;
    updateTime: string;
    url: string;
    thumbnailUrl: string;
}

const Videos: VideoItem[] =[{
    title: `GOAT Network (BTC L2) : (EP6) "Alpha Mainnet is Live!"`,
    updateTime: `2/22/2025`,
    url: `https://www.youtube.com/watch?v=0GdC3wpxmhM&ab_channel=GOATNetwork`,
    thumbnailUrl: `https://img.youtube.com/vi/0GdC3wpxmhM/hqdefault.jpg`
}];

const YoutubeSlide = ({ url, isSelected }: { url: string; isSelected?: boolean }) => (
    <ReactPlayer
        width="100%"
        height={isMobile ? '220px' : '675px'}
        url={url}
        playing={isSelected}
        controls={true}
        style={{
            borderRadius: '20px',
            marginBottom: '20px'
        }}
    />
);

export default function VideoCarousel() {
    return (
        <Wrapper id="videoCarousel">
            <Carousel
                showArrows={false}
                showStatus={false}
                showIndicators={false}
                showThumbs={false}
                renderThumbs={() => Videos.map((video, index) => (
                    <>
                        <ThumbnailContainer key={index}>
                            <img
                                src={video.thumbnailUrl}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '10px'
                                }}
                            />
                        </ThumbnailContainer>
                        <TYPE.main
                            color="#fff"
                            fontSize={18}
                            textAlign="left"
                        >{video.title}</TYPE.main>
                        <TYPE.desc
                            color="#6B6D75"
                            fontSize={15}
                            textAlign="left"
                        >{video.updateTime}</TYPE.desc>
                    </>
                ))}
            >
                {Videos.map((video, index) => (
                    <VideoContainer key={index}>
                        <YoutubeSlide url={video.url} />
                        <TYPE.main
                            color="#fff"
                            fontSize={18}
                            textAlign="left"
                        >{video.title}</TYPE.main>
                        <TYPE.desc
                            color="#6B6D75"
                            fontSize={12}
                            textAlign="left"
                        >{video.updateTime}</TYPE.desc>
                    </VideoContainer>
                ))}
            </Carousel>
        </Wrapper>
    );
}
